{
	"title": "Glossary",
	"subtitle": "All terms from your materials in one place",
	"intro": {
		"title": "Why a glossary",
		"body": "Terms are collected from your materials on their own, with a definition in the language of the source and a link to the fragment they came from.",
		"bullets": [
			"Builds itself as you upload materials",
			"Every term shows where it came up",
			"Any term turns into flashcards in one action"
		]
	},
	"empty": "No terms yet",
	"emptyDescription": "Run term extraction so StudyHub builds the glossary for this material.",
	"globalEmptyTitle": "No terms yet",
	"globalEmptyDescription": "Generate terms from a material or add one manually — they will show up here.",
	"noSearchResults": "Nothing found for your query",
	"openMaterial": "Open material",
	"goToMaterials": "Go to materials",
	"generate": "Generate",
	"generateConfirm": {
		"title": "Regenerate glossary?",
		"body": "AI will re-extract terms from the material. Existing AI terms may change; manually added terms are kept.",
		"confirm": "Regenerate"
	},
	"generatePick": {
		"title": "Generate from a material",
		"hint": "Pick a material — StudyHub will extract key terms and definitions.",
		"cta": "Generate"
	},
	"add": {
		"title": "Add term",
		"description": "The term will appear in your glossary. It is linked to a material when opened from a material tab or note.",
		"termPlaceholder": "e.g. Krebs cycle",
		"definitionPlaceholder": "A short explanation of the term",
		"submit": "Add",
		"success": "Term added",
		"failed": "Couldn't add the term",
		"cta": "Add term"
	},
	"termCount": "{count, plural, one {# term} other {# terms}}",
	"search": "Search term",
	"tabs": {
		"all": "All",
		"marked": "Marked",
		"recent": "Recent"
	},
	"filters": {
		"status": "Status",
		"importance": "Importance",
		"allStatuses": "All statuses",
		"allImportance": "Any importance",
		"high": "High",
		"medium": "Medium",
		"low": "Low",
		"verified": "Verified",
		"aiGenerated": "AI generated",
		"userCreated": "User created",
		"title": "Filters",
		"button": "Filters",
		"material": "Material",
		"reset": "Reset filters"
	},
	"sort": {
		"alpha": "Alphabetical",
		"importance": "By importance",
		"frequency": "By frequency"
	},
	"view": {
		"byMaterial": "By material",
		"list": "List"
	},
	"group": {
		"manual": "Created manually",
		"otherMaterial": "Other materials"
	},
	"table": {
		"term": "Term",
		"definition": "Definition",
		"importance": "Importance",
		"actions": "Actions"
	},
	"term": {
		"termLabel": "Term",
		"definition": "Definition",
		"examples": "Examples",
		"addExample": "Add example",
		"examplePlaceholder": "Usage example",
		"relatedTerms": "Related terms",
		"relatedCountLabel": "{count, plural, one {# related material} other {# related materials}}",
		"addToFlashcards": "Add to flashcards",
		"viewInMaterial": "Open in material",
		"edit": "Edit",
		"delete": "Delete",
		"verify": "Verify",
		"add": "Add term",
		"addedToFlashcards": "Already in flashcards"
	},
	"selectedCount": "Selected: {count}",
	"clearSelection": "Clear",
	"exportToFlashcards": "Create flashcards from selected",
	"generateQuizFromSelected": "Create quiz from selected",
	"quizName": "Terms quiz",
	"quizDescription": "AI will build questions from the selected terms and their definitions. The quiz will be ready in about a minute.",
	"quizGenerate": "Generate",
	"quizQueued": "Quiz is being generated — it'll be ready shortly",
	"quizFailed": "Couldn't start quiz generation",
	"loadFailed": "Couldn't load the glossary",
	"retry": "Retry",
	"generation": {
		"inProgress": "Extracting terms…",
		"ready": "Glossary updated"
	},
	"generating": "Building the term glossary…",
	"generatingDescription": "Extracting the key terms from this material. It will take a couple of minutes.",
	"generateStarted": "Glossary generation started",
	"generateFailed": "Couldn't start generation",
	"exportSetName": "Glossary",
	"exportDone": "Flashcards created: {count}",
	"exportFailed": "Couldn't export",
	"editTerm": "Edit term",
	"editSave": "Save",
	"editCancel": "Cancel",
	"editSaved": "Term updated",
	"editFailed": "Couldn't save",
	"deleteTerm": "Delete term",
	"deleteConfirm": "Delete term \"{term}\"?",
	"deleteConfirmDescription": "The term will move to trash for 30 days.",
	"deleteCancel": "Cancel",
	"deleteSubmit": "Delete",
	"deleteSuccess": "Term deleted",
	"deleteFailed": "Couldn't delete",
	"verifyTerm": "Mark as verified",
	"verifySuccess": "Term verified",
	"verifyFailed": "Couldn't verify",
	"verifiedBadge": "Verified",
	"aiGeneratedBadge": "AI",
	"filterByMaterial": "All materials",
	"applyAll": "Apply",
	"badge": {
		"verified": "Verified"
	},
	"tooltip": {
		"openInGlossary": "Open in glossary",
		"verify": "Verify"
	},
	"popover": {
		"more": "Show more"
	}
}
